var portfolio = {
	addTransactionAction: "Transactie Toevoegen",
	topFlopTitle: "Top/Flop Positie",
	breakdownsTitle: "Breakdown-informatie",
	assetClassBreakdownTitle: "Activaklassen",
	currencyBreakdownTitle: "Valuta's",
	sectorBreakdownTitle: "Sectoren",
	sectorBreakdownSubtitle: "Weging naar totale portfolio",
	evaluationChartTitle: "Portfolio-waarde",
	unrealizedPerformancePositionsTitle: "Ongerealiseerde prestaties",
	weightPositionsTitle: "Portfolio-gewicht",
	editPortfolioAction: "Portfolio Bewerken",
	deletePortfolioAction: "Portfolio Verwijderen",
	createPortfolioAction: "Creëer Portfolio",
	addPortfolioAction: "Creëer Portfolio",
	editTransactionAction: "Transactie Bewerken",
	deleteTransactionAction: "Transactie verwijderen",
	errorAlertLabel: "Er is een fout opgetreden",
	transactionLimitExceeded: "Transactielimiet overschreden",
	portfolioLimitExceeded: "Portfoliolimiet overschreden",
	info: "Info",
	noPositionsAlert: "De portfolio bevat geen posities, voeg een aankooptransactie toe",
	noTransactionsAlert: "De portfolio bevat geen transacties, voeg een aankooptransactie toe",
	noPortfolios: {
		title: "Info",
		message: "No portfolio has been created yet. Please click on the \"Add portfolio\" button and fill out the form to create a portfolio."
	},
	tab: {
		overview: "Overzicht",
		positions: "Posities",
		transactions: "Transacties",
		news: "Nieuws"
	},
	showActions: "Toon acties"
};
var nl = {
	portfolio: portfolio
};

export { nl as default, portfolio };
